// @flow

import React from 'react';
import styled from 'styled-components';

import {colors} from 'js-libs/sweetcommons/styles';
import {gt} from 'app/utils/i18n';

import {NavigationList} from './NavigationList';
import {UserBox} from './UserBox';

const StyledSidebarDiv = styled.div`
  background: ${colors.darkGreen};
  display: flex;
  box-shadow: 2px 0 2px rgba(0, 0, 0, 0.25);
  position: absolute;
  z-index: 100;
  height: 100%;
  overflow: hidden;

  transform: translate(-220px, 0);
  opacity: 0;
  transition: all 250ms;

  &.opened {
    transform: none;
    opacity: 1;
    overflow: auto;
  }

  > div {
    width: 210px;
    padding: 0 10px;

    > hr {
      border-top: 1px solid ${colors.mediumGreen};
      margin: 1rem 0;
    }

    .no-pad {
      margin: 0 -9px;
    }

    .btn-xs {
      font-size: 0.75rem;
    }

    .buttons-line {
      display: flex;
      justify-content: between;

      > * {
        flex-grow: 1;
        margin-left: 0.25rem;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
`;

type Props = {
  opened: boolean,
  onToggle: () => any,
};

export const NavSidebar = ({opened, onToggle}: Props) => (
  <StyledSidebarDiv className={opened ? 'opened' : ''}>
    <div>
      <div className="no-pad">
        <NavigationList onToggle={onToggle} />
      </div>
      <UserBox onToggle={onToggle} />
      <hr />
      <div className="buttons-line">
        {/*<button className="btn btn-xs btn-ssblock btn-outline-primary"><i className="fa fa-tags" /> Manage tags</button>*/}
        <a className="btn btn-xs btn-sblock btn-outline-light" href="/help/">
          <i className="fa fa-question-circle" /> {gt('Help')}
        </a>
      </div>
    </div>
  </StyledSidebarDiv>
);
